export default "__VITE_ASSET__819f95f5__"